import { HeadCell } from '../../../../component/table/interfaces/TableInterface';

export const HEAD_CELL: Array<HeadCell> = [
    { id: 'FuncionarioId', label: 'Usuário' },
    { id: 'DataLeitura', label: 'Data de leitura', format: ['dateTime'] },
];